const state = {
    head:{
        icon: "https://www.ctrip.com/favicon.ico",
        link: 'https://www.ctrip.com/',
        title: '携程'
    },
    data:{
        link: 'https://www.ctrip.com',
        img_src: require('@/assets/images/famous/xiecheng123.png')
    },
}
const mutations = {
    setRightBoxNewsData (state, data) {
        state.data = data
    },
}
const actions = {
}

export default {
    namespaced: true,
    state,
    mutations,
    actions
}
